<template>
    <div class="form-product">
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveBonProduct()" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
        </p>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.isBonProductie') }}</p>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group mt-3">
                  <label>Categorie produs*</label>
                  <select v-model="selectedCategory" class="form-control" :disabled="isEdit">
                    <option
                      v-for="category in categories"
                      :key="category.value"
                      :value="category.value"
                    >
                      {{ category.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.productName')}}*</label>
                  <v-select
                    v-model="productNameRecipe"
                    :options="searchResults"
                    label="name"
                    placeholder="Caută un produs..."
                    :filterable="false"
                    @search="term => fetchProducts(term)"
                    @input="onProductSelect"
                    :disabled="isEdit"
                  >
                    <template #no-options>
                      <span v-if="!loading">Niciun produs găsit</span>
                    </template>
                  </v-select>

                  <div v-if="loading" class="v-select-loader"></div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="cantitateProdusa">Cantitate produsa*</label>
                  <el-input
                    v-model="bonProduct.cantitateProdusa"
                    type="number"
                    min="0"
                    placeholder="Introdu cantitatea"
                  ></el-input>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.location') }}</label>
                  <select class="form-control" v-model="selectedLocationId" :disabled="isEdit">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="gestiune">{{ $t('gestiune.gestiune') }}*</label>
                  <select v-model="bonProduct.fromGestiune" class="form-control" :disabled="isEdit">
                    <option disabled :value="null">Selectează gestiunea</option>
                    <option
                      v-for="gestiune in filteredGestiuni"
                      :key="gestiune.id"
                      :value="gestiune.id"
                    >
                      {{ gestiune.name }}
                    </option>
                    <option
                      v-if="bonProduct.fromGestiune && !filteredGestiuni.some(g => g.id === bonProduct.fromGestiune)"
                      :value="bonProduct.fromGestiune"
                    >
                      {{ getGestiuneName(bonProduct.fromGestiune) }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="serie">{{ $t('invoice.series') }}*</label>
                  <select v-model="bonProduct.serie" class="form-control" @change="handleSerieChange" :disabled="isEdit">
                    <!-- Placeholder -->
                    <option disabled value="">Selectează seria</option>

                    <option
                      v-for="serie in seriesOptionsWithAdd"
                      :key="serie.id"
                      :value="serie.id"
                    >
                    {{
                      serie.id === 'add'
                        ? serie.name
                        : `${serie.name} - ${serie.currentNumber || bonProduct.documentNumber}`
                    }}
                    </option>

                    <option
                      v-if="bonProduct.serie && !seriesOptionsWithAdd.some(s => s.id === bonProduct.serie)"
                      :value="bonProduct.serie"
                    >
                      {{ bonProduct.serie }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="data">{{ $t('gestiune.data') }}</label>
                  <input
                    type="datetime-local"
                    class="form-control"
                    v-model="bonProduct.date"
                    :disabled="!selectedLocationId"
                    @change="checkValidatedAfter(bonProduct.date, 'bonProduct.date')"
                    :placeholder="$t('Selectează data și ora')"
                    :max="today"
                  />
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="lot">{{ $t('gestiune.lot') }}</label>
                  <el-input v-model="bonProduct.lot" placeholder="Introdu lotul" :disabled="isEdit" />
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="dataProductie">{{ $t('gestiune.dataProductie') }}</label>
                  <input
                    type="datetime-local"
                    class="form-control"
                    v-model="bonProduct.dataProductie"
                    :placeholder="$t('Selectează data și ora producției')"
                    :max="today"
                  />
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="dataExpirare">{{ $t('gestiune.dataExpirare') }}</label>
                  <input
                    type="datetime-local"
                    class="form-control"
                    v-model="bonProduct.dataExpirare"
                    :placeholder="$t('Selectează data și ora expirării')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="col-md-12">
            <p>{{$t('gestiune.addProductInBonProductie')}}</p>
            <hr class="sm">
          </div>

          <el-table
            :data="tableData"
            style="width: 100%"
            v-loading="loadingTable"
            element-loading-text="Se încarcă datele..."
          >
            <el-table-column :label="$t('gestiune.productName')" prop="productName">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column;">
                  <span>{{ scope.row.productName }}</span>
                  <span
                    v-if="scope.row.stoc && scope.row.stoc"
                    :style="{
                      fontSize: '12px',
                      color:
                        scope.row.stoc < 0
                          ? 'red'
                          : scope.row.stoc > 0
                          ? 'green'
                          : 'gray'
                    }"
                  >
                    Stoc: {{ Number(scope.row.stoc).toFixed(2) }}
                  </span>
                  <span :class="getCategoryClass(scope.row.categorie)">
                    {{ scope.row.categorie }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.gestiune_descarcare')" prop="gestiune">
              <template slot-scope="scope">
                {{
                  getGestiuneName(bonProduct.fromGestiune)
                }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.cantitateConsumata')" prop="cantitate">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.cantitate"
                  size="mini"
                  type="number"
                  disabled
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.scazamant')" prop="scazamantValue">
              <template slot-scope="scope">
                <span v-if="scope.row.scazamantType === 'procent'">
                  {{ scope.row.scazamantValue }}%
                </span>
                <span v-else>
                  {{ scope.row.scazamantValue }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.um')" prop="um">
              <template slot-scope="scope">
                {{ scope.row.um }}
              </template>
            </el-table-column>

            <!-- <el-table-column :label="$t('gestiune.cost')" prop="price">
              <template slot-scope="scope">
                {{ scope.row.price }}
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="card col-md-6 no-padding">
        <div class="card-content">
          <div class="modal-body">
             <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="gestionar">{{ $t('gestiune.manager') }}</label>
                  <el-input v-model="bonProduct.manager" placeholder="Introdu numele gestionarului" />
                </div>

                <div class="form-group">
                  <label for="primitor">{{ $t('gestiune.receiver') }}</label>
                  <el-input v-model="bonProduct.receiver" placeholder="Introdu numele primitorului" />
                </div>

                <div class="form-group">
                  <label for="notaInterna">{{ $t('gestiune.internalNote') }}</label>
                  <el-input v-model="bonProduct.internalNote" placeholder="Adaugă o notă internă" type="textarea" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vmodal name="openEditPriceModal" height="auto" width="600" class="openEditPriceModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{$t('gestiune.editPrice')}}</p>
            </div>
            <div class="modal-body">
              <div class="row">

                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('gestiune.pretVanzare')}}</label>
                    <input type="number" v-model="item.pretVanzare" class="form-control" :placeholder="$t('gestiune.pretVanzare')" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.currency')}}</label>
                    <select v-model="item.currency" class="form-control">
                      <option value="RON">RON</option>
                      <option value="EURO">EURO</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.pretPerUnitate')}}</label>
                    <input type="number" v-model="item.pretPerUnitate" class="form-control" :placeholder="$t('gestiune.pretPerUnitate')" />
                  </div>
                </div>

              </div>
            </div>

            <div class="modal-footer">
              <div class="button-group">
                <button class="btn btn-icon btn-success mar-rt-10 save">
                  {{$t('general.save')}}
                </button>
                <a class="btn btn-danger btn-icon mar-rt-10 delete" @click="$modal.hide('openEditPriceModal')">
                  {{$t('general.cancel2')}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </vmodal>

      <ManagementSeriesAdd
        :locations="locations"
        :grouped-locations="groupedLocations"
        :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
        @getSeries="getSeries"
      />
    </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
  import swal from 'sweetalert2'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      PSwitch,
      ManagementSeriesAdd
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        loadingTable: false,
        productNameRecipe: null,
        selectedCategory: 'Produs finit (Reteta)',
        selectedLocationId: '',
        selectedLocation: null,
        locations: [],
        costPerUnit: 0.00,
        pricePerUnit: 100.00,
        totalCost: 0.00,
        gestiuneOptions: [],
        seriesOptions: [],
        searchResults: [],
        bon_productOptions: [],
        loading: false,
        searchDebounceTimer: null,
        currencyOptions: [
          { code: 'RON', name: 'Leu Românesc (RON)' },
          { code: 'EUR', name: 'Euro (EUR)' },
          { code: 'USD', name: 'Dolar American (USD)' }
        ],
        categories: [
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }
        ],
        isEdit: !!this.route.params.series && !!this.route.params.number,
        bonProduct: {
          date: null,
          fromGestiune: null,
          serie: null,
          currency: 'RON',
          manager: '',
          receiver: '',
          internalNote: '',
          lot: '',
          dataProductie: getLocalDateTimeString(),
          dataExpirare: getLocalDateTimeString(),
          cantitateProdusa: ''
        },
        tableData: [],
        editIndex: null,
        item: {
          productName: '',
          um: 'BUC',
          cantitate: null
        }
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', name: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocation) return []

        return this.gestiuneOptions.filter(g =>
          g.externalLocationId === this.selectedLocation.true_id &&
          (
            g.categorie === 'Produs finit (Reteta)' ||
            g.categorie === 'Semifabricate (Reteta)'
          )
        )
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        if (!this.isEdit) {
          this.bonProduct.fromGestiune = null
          this.bonProduct.serie = null
          this.bonProduct.lot = ''
        }

        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)
            }
            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const s = this.route && this.route.params && this.route.params.series
          const inv = this.route && this.route.params && this.route.params.number
          if (s && inv) {
            this.fetchBonProduct(s, inv)
          }
        }
      },
      productNameRecipe (newVal) {
        if (!newVal) {
          this.tableData = []
        }
      },
      selectedCategory (newVal) {
        this.productNameRecipe = null
        this.selectedLocationId = ''
        this.selectedLocation = null
        this.bonProduct = {
          cantitateProdusa: null,
          fromGestiune: null,
          serie: null,
          lot: '',
          dataProductie: getLocalDateTimeString(),
          dataExpirare: getLocalDateTimeString(),
          date: null
        }

        this.tableData = []
      },
      'bonProduct.fromGestiune': function (newGestiune) {
        if (!newGestiune) return
        if (this.productNameRecipe && this.productNameRecipe.reteta && Array.isArray(this.productNameRecipe.reteta.items)) {
          this.populateTableFromReteta(this.productNameRecipe.reteta.items)
        }
      },
      'bonProduct.cantitateProdusa': function (newVal) {
        this.tableData = this.tableData.map(item => {
          const bazaCantitate = item.bazaCantitate || item.cantitate || 0
          const bazaPrice = item.bazaPrice || item.price || 0
          let cantitate = bazaCantitate
          let price = bazaPrice

          if (newVal && !isNaN(newVal) && parseFloat(newVal) > 0) {
            cantitate = bazaCantitate * newVal
            price = bazaPrice * newVal
          }

          if (item.scazamantValue && item.scazamantType) {
            if (item.scazamantType === 'procent') {
              // scazamantValue este procentaj
              price = price * (1 - parseFloat(item.scazamantValue) / 100)
            } else {
              // scazamantType este unitate numerică
              cantitate = cantitate - parseFloat(item.scazamantValue)
              if (cantitate < 0) cantitate = 0
            }
          }

          return {
            ...item,
            cantitate: cantitate.toFixed(2),
            price: price.toFixed(2),
            bazaCantitate
          }
        })
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveBonProduct() }
        })
      },
      openEditPriceModal () {
        this.$modal.show('openEditPriceModal')
      },
      handleSerieChange (event) {
        const val = event.target.value
        if (val === 'add') {
          this.openSeriesModal()
          this.bonConsum.serie = null
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      getEmptyItem () {
        return {
          productName: '',
          um: 'buc',
          cantitate: null,
          editIndex: null
        }
      },
      getCategoryClass (categorie) {
        if (!categorie) return ''
        const name = categorie.replace(' (Reteta)', '').trim().toLowerCase()
        return name.replace(/\s+/g, '-')
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      getGestiuneName (id) {
        const gestiune = this.gestiuneOptions.find(g => g.id === id || g._id === id)
        return gestiune ? gestiune.name : id
      },
      async checkValidatedAfter (date, field) {
        try {
          const selectedDate = date
          if (!selectedDate) return false

          const products = [this.productNameRecipe._id]

          const queryParams = new URLSearchParams({
            date: new Date(selectedDate).toISOString(),
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocationId
          })

          const body = products.length > 0 ? { products } : null

          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/validated-after-products?${queryParams.toString()}`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: body ? JSON.stringify(body) : null
            }
          )

          if (!response.ok) throw new Error(`Request failed: ${response.status}`)

          const data = await response.json()
          console.log('Response from validated-after:', data)

          if (data.exists) {
            await swal({
              icon: 'warning',
              title: 'Atenție!',
              text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
            })
            if (field) this[field] = null
            return false
          }

          return true
        } catch (err) {
          console.error(err)
          swal({
            icon: 'error',
            title: 'Eroare!',
            text: 'Nu s-a putut verifica inventarul.'
          })
          return false
        }
      },
      onProductSelect (product) {
        if (!product || !product.reteta || !Array.isArray(product.reteta.items)) {
          console.warn('Produsul selectat nu conține rețetă validă.')
          this.tableData = []
          return
        }

        this.productNameRecipe = product

        // Reset tabel înainte să adaugi noi date
        // this.tableData = []

        if (this.bonProduct.fromGestiune && this.locationID) {
          this.populateTableFromReteta(product.reteta.items)
        }
      },
      async fetchBonProduct (seriesParam, invoiceNumberParam) {
        try {
          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument?tip=bon_productie&series=${seriesParam}&number=${invoiceNumberParam}&externalCompanyId=${this.companyID}`
          )

          if (!response.ok) throw new Error('Failed to fetch bon de productie')

          const data = await response.json()

          if (!data || !Array.isArray(data.documents) || !data.documents.length) {
            throw new Error('Bon de productie inexistent')
          }

          const bon = data.documents[0]

          const extra = bon.extraFields || []
          const getField = (key) => {
            const field = extra.find(f => f.key === key)
            return field ? field.value : ''
          }

          const categorie = getField('categorie')
          if (categorie) {
            this.selectedCategory = categorie
          }

          const lot = getField('lot')

          const produsPrincipal = bon.items && bon.items[0]

          if (produsPrincipal) {
            if (!this.searchResults.length) {
              await this.fetchProducts(produsPrincipal.name, true)
              await this.$nextTick()
            }

            console.log('produsPrincipal.name', produsPrincipal.name)
            const produsGasit = this.searchResults.find(p => p.name === produsPrincipal.name)

            console.log('produsGasit', produsGasit)

            if (produsGasit) {
              this.productNameRecipe = produsGasit
              this.onProductSelect(produsGasit) // ⬅️ declanșează select automat
            } else {
              console.warn('Produsul principal nu a fost găsit în lista de produse')
            }

            this.bonProduct.cantitateProdusa = produsPrincipal.quantity
          }

          let selectedSerie = this.seriesOptions.find(s => s.id === bon.series)
          if (!selectedSerie) {
            // Opțional: adaugă seria documentului dacă nu există
            selectedSerie = { id: bon.series, name: bon.series }
            this.seriesOptions.push(selectedSerie)
            console.warn(`Seria "${bon.series}" nu exista, a fost adaugată automat.`)
          }
          this.bonProduct.serie = selectedSerie.id

          const gestiuneToObj = this.gestiuneOptions.find(g => g.id === bon.gestiune_to || g._id === bon.gestiune_to || g.name === bon.gestiune_to)

          this.bonProduct = {
            ...this.bonProduct,
            fromGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
            toGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
            serie: bon.series,
            date: bon.date,
            documentNumber: bon.documentNumber,
            manager: getField('manager'),
            receiver: getField('receiver'),
            internalNote: getField('internalNote'),
            commandProject: getField('commandProject'),
            lot
          }

          this.consumptionType = bon.type

          if (bon.externalLocationId && this.locations && this.locations.length) {
            // Căutăm locația potrivită în groupedLocations
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (bon.externalLocationId && loc.true_id === bon.externalLocationId) ||
                (bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (bon.externalLocationIdTo && this.locations && this.locations.length) {
            let foundToLocation = null
            for (const group of this.groupedLocations) {
              foundToLocation = group.locations.find(loc =>
                loc.true_id === bon.externalLocationIdTo ||
                loc.inv_fiscal_code === bon.vatNumberTo
              )
              if (foundToLocation) break
            }
          }
        } catch (error) {
          console.error('Error fetching bon de transfer:', error)
        }
      },
      async populateTableFromReteta (items) {
        console.log('populateTableFromReteta', items)
        if (!items || !items.length) {
          this.tableData = []
          return
        }

        const produsFactor = parseFloat(this.bonProduct.cantitateProdusa) || 1

        this.tableData = items.map(item => {
          const product = item.productDetails || {}
          const bazaCantitate = parseFloat(item.qty) || 0

          return {
            productName: product.name || item.name || 'N/A',
            um: item.um || product.um || 'N/A',
            cantitate: ((bazaCantitate * produsFactor).toFixed(2)),
            bazaCantitate,
            price: 0,
            bazaPrice: 0,
            id: product._id || item.posId || null,
            stoc: 0,
            categorie: product.categorie || '',
            scazamantValue: item.scazamantValue || 0,
            scazamantType: item.scazamantType || ''
          }
        })

        console.log('tableData populated:', this.tableData)
      },

      // async fetchStockForReteta (items) {
      //   console.log(items)
      //   const productIDs = items.map(item => item.productDetails._id).filter(Boolean)

      //   if (!productIDs.length) return

      //   this.loadingTable = true
      //   try {
      //     const params = new URLSearchParams()
      //     params.append('externalCompanyId', this.companyID)
      //     params.append('externalLocationId', this.selectedLocation.true_id)
      //     params.append('gestiune', this.bonProduct.fromGestiune)
      //     productIDs.forEach(id => params.append('product_ids', id))

      //     const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/stock?${params.toString()}`)
      //     const data = await response.json()

      //     const stocuri = data.stock || []

      //     this.tableData = items
      //       .map(item => {
      //         const product = item.productDetails || {}
      //         const stoc = stocuri.find(s => s.product_id === product._id)

      //         if (!stoc) return null // ← elimină produsul dacă nu e în stoc

      //         const bazaCantitate = parseFloat(item.qty || 0)
      //         const produsFactor = parseFloat(this.bonProduct.cantitateProdusa || 1)

      //         const price = stoc.average_price || 0

      //         return {
      //           productName: product.name,
      //           um: item.um || product.um || 'N/A',
      //           cantitate: (bazaCantitate * produsFactor).toFixed(2),
      //           bazaCantitate,
      //           price: (price * produsFactor).toFixed(2),
      //           bazaPrice: price,
      //           id: product._id,
      //           stoc: stoc.quantity || 0,
      //           categorie: product.categorie,
      //           scazamantValue: item.scazamantValue,
      //           scazamantType: item.scazamantType
      //         }
      //       })
      //       .filter(Boolean)
      //   } catch (err) {
      //     console.error('Eroare fetch stocuri:', err)
      //     this.tableData = []
      //   } finally {
      //     this.loadingTable = false
      //   }
      // },
      saveProduct () {
        if (!this.item.productName || !this.item.cantitate) {
          swal({
            title: 'Eroare',
            text: 'Te rugăm să completezi toate câmpurile necesare!',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        let productName = this.item.productName
        if (typeof productName === 'object') {
          if (productName._id) {
            this.item.posId = productName._id
          }
          productName = productName.name || productName.product_code || ''
        }

        const newItem = {
          ...this.item,
          productName,
          posId: this.item.posId
        }

        if (this.editIndex !== null && this.editIndex >= 0) {
          this.$set(this.tableData, this.editIndex, newItem)
        } else {
          this.tableData.push(newItem)
        }

        this.item = this.getEmptyItem()
        this.editIndex = null
        this.$modal.hide('addProductModal')
      },
      editRow (row) {
        const index = this.tableData.indexOf(row)
        if (index === -1) return

        this.editIndex = index
        this.item = {
          productName: { name: row.productName }, // pentru v-select
          um: row.um,
          cantitate: row.cantitate,
          posId: row.posId || null
        }

        this.$modal.show('addProductModal')
      },
      deleteRow (row) {
        const index = this.tableData.indexOf(row)

        if (index !== -1) {
          this.tableData.splice(index, 1)
        }
      },
      // Funcția internă care face efectiv fetch-ul
      fetchProducts (searchTerm, immediate = false) {
        return new Promise((resolve) => {
          // Anulează timer-ul precedent
          if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer)
            this.searchDebounceTimer = null
          }

          const delay = immediate ? 0 : 300

          this.searchDebounceTimer = setTimeout(async () => {
            if (!searchTerm || searchTerm.length < 2) {
              this.searchResults = []
              resolve()
              return
            }

            this.loading = true
            try {
              const categorieParam = this.selectedCategory
                ? `&categorie=${encodeURIComponent(this.selectedCategory)}`
                : ''
              const response = await fetch(
                `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}&name=${searchTerm}${categorieParam}`
              )
              const data = await response.json()
              this.searchResults = Array.isArray(data.products) ? data.products : []
              console.log('this.searchResults', this.searchResults)
            } catch (error) {
              console.error('Error fetching products:', error)
              this.searchResults = []
            } finally {
              this.loading = false
              resolve() // important: rezolvăm promise-ul după ce fetch-ul s-a terminat
            }

            this.searchDebounceTimer = null
          }, delay)
        })
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          console.log('Date primite de la server:', data.gestiuni)
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map(gest => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || '',
              categorie: gest.categorie || ''
            }))
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async getSeries (vatNumber) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'bon_productie'
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Serii primite:', data.series)

          if (Array.isArray(data.series)) {
            this.seriesOptions = data.series.map(serie => ({
              id: serie._id,
              name: serie.series,
              currentNumber: serie.currentNumber
            }))
          } else {
            console.error('Format invalid pentru series:', data)
          }
        } catch (error) {
          console.error('Error fetching series:', error)
        }
      },
      async saveBonProduct () {
        const problems = []

        if (!this.selectedCategory) {
          problems.push('Selectează categoria produsului.')
        }
        if (!this.productNameRecipe || !this.productNameRecipe._id) {
          problems.push('Selectează produsul.')
        }
        if (!this.bonProduct.cantitateProdusa || isNaN(this.bonProduct.cantitateProdusa) || parseFloat(this.bonProduct.cantitateProdusa) <= 0) {
          problems.push('Introdu o cantitate produsă mai mare decât 0.')
        }
        if (!this.selectedLocationId || !this.selectedLocation) {
          problems.push('Selectează locația.')
        }
        if (!this.bonProduct.fromGestiune) {
          problems.push('Selectează gestiunea.')
        }
        if (!Array.isArray(this.gestiuneOptions) || !this.gestiuneOptions.length) {
          problems.push('Gestiunile nu sunt încărcate.')
        }
        if (!Array.isArray(this.seriesOptions)) {
          problems.push('Seriile nu sunt încărcate.')
        }

        const selectedSerie = Array.isArray(this.seriesOptions)
          ? this.seriesOptions.find(serie => serie.id === this.bonProduct.serie)
          : null

        if (!this.bonProduct.serie || !selectedSerie || selectedSerie.id === 'add') {
          problems.push('Selectează o serie validă.')
        }
        if (!this.tableData || this.tableData.length === 0) {
          problems.push('Rețeta nu are produse. Selectează un produs cu rețetă și o gestiune.')
        }
        if (!this.bonProduct.date) {
          problems.push('Selectează data documentului.')
        }

        if (problems.length) {
          swal({
            icon: 'error',
            title: 'Nu se poate salva',
            html: '<ul style="text-align:left;margin:0 auto;padding-left:18px;display:inline-block;">' +
              problems.map(problem => `<li>${problem}</li>`).join('') +
              '</ul>'
          })
          return
        }

        const serieName = `${selectedSerie.name}`

        const isValid = await this.checkValidatedAfter(
          this.bonProduct.date,
          'bonProduct.date'
        )
        if (!isValid) return

        const bonProductData = {
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          series: serieName,
          tip: 'bon_productie',
          gestiune_from: this.bonProduct.fromGestiune,
          gestiune_to: this.bonProduct.fromGestiune,
          lot: this.bonProduct.lot,
          items: [{
            posId: this.productNameRecipe._id,
            name: this.productNameRecipe.name,
            quantity: this.bonProduct.cantitateProdusa,
            um: this.productNameRecipe.um
          }],
          currency: this.bonProduct.currency,
          extraFields: Object.entries({
            manager: this.bonProduct.manager,
            receiver: this.bonProduct.receiver,
            internalNote: this.bonProduct.internalNote,
            lot: this.bonProduct.lot,
            dataProductie: this.bonProduct.dataProductie,
            dataExpirare: this.bonProduct.dataExpirare,
            categorie: this.selectedCategory
          }).map(([key, value]) => ({ key, value }))
        }

        if (this.bonProduct.date) {
          bonProductData.date = this.bonProduct.date
        }
        if (this.bonProduct.documentNumber) {
          bonProductData.documentNumber = this.bonProduct.documentNumber
        }

        swal({
          title: 'Salvare în curs...',
          text: 'Se salvează Bonul de Proctie. Așteaptă te rog.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false
        })

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bon`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bonProductData)
          })

          const data = await response.json()

          swal.close()

          if (response.ok) {
            console.log('Bon de procutie salvat cu succes!', data)

            swal({
              title: 'Succes',
              text: 'Bon de procutie a fost salvat cu succes!',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })

            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          } else {
            console.error('Eroare la salvarea bonului de procutie', data)

            const serverMessage = (data && (data.message || data.error)) || 'A apărut o eroare la salvarea bonului de producție.'
            swal({
              icon: 'error',
              title: 'Eroare',
              text: serverMessage
            })
          }
        } catch (error) {
          swal.close()
          console.error('Eroare la trimiterea cererii', error)

          swal({
            icon: 'error',
            title: 'Eroare',
            text: error && error.message
              ? `A apărut o problemă la trimiterea cererii: ${error.message}`
              : 'A apărut o problemă la trimiterea cererii.'
          })
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
.form-product .el-table tbody .cell {
  height: 95px !important;
}
</style>
<style scoped>
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.marfa {
  background-color: orange;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.semifabricate {
  background-color: #219653;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.materii-prime {
  background-color: #2f80ed;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.produs-finit {
  background-color: #674BD2;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.ambalaje {
  background-color: #007bff;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.materiale-consumabile {
  background-color: #007bff;
  color: white;
  padding: 2px 15px;
  border-radius: 50px;
  font-size: 11px;
  display: inline-block;
  margin-top: 2px;
  text-align: center;
  width: fit-content;
}
.v-select-wrapper {
  position: relative;
}

.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.btn-primary {
  padding: 5px 50px;
}
.el-select,
.el-input {
  display: block;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.cost-summary-container {
  display: flex;
  justify-content: flex-end; /* Aliniere la dreapta */
  margin-top: 20px;
}

.cost-summary {
  width: 250px;
  text-align: right;
}

.cost-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 5px;
}
.v-select.disabled .dropdown-toggle input {
  background-color: transparent !important;
}
.cost-value {
  font-weight: bold;
}

.edit-label {
  color: #f97316; /* Portocaliu */
  cursor: pointer;
}

.edit-icon {
  font-size: 12px;
  margin-left: 5px;
  cursor: pointer;
}

.divider {
  width: 100%;
  border: 0;
  height: 1px;
  background: #ddd;
  margin: 10px 0;
}

.total {
  font-weight: bold;
  font-size: 16px;
}

.total-value {
  color: #6b21a8; /* Mov */
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProductForm.vue